<div fxLayout="column">
  <mat-card class="card-header">
    <mat-card-title id="id_condition_header">
      <!-- Condition Description -->
      {{ 'LABEL_CONDITION_HEADER' | translate }}
    </mat-card-title>
    <form [formGroup]="formGroupDescription">
      <div fxFlex fxLayout fxLayoutGap="15px">

        <!-- LABEL_DISCOUNT_TYPE -->
        <div fxFlex fxLayout="column">
          <div fxLayout="row">
            <mat-form-field>
              <mat-label>{{'LABEL_DISCOUNT_TYPE' | translate}}</mat-label>
              <mat-select id="id_disc_type_dropdown" #discountTypeSelect formControlName="discountTypeSelect" required>
                <mat-option [id]="'id_disc_type_data_' + (i+1)" *ngFor="let option of discountTypes; let i = index" [value]="option.value">
                  {{option.viewValue}}
                </mat-option>
              </mat-select>
              
              <mat-error *ngIf="formGroupDescription.controls['discountTypeSelect'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- LABEL_DISCOUNT_RATE_ROUNDING -->
          <div fxLayout="row">
            <mat-form-field>
              <mat-label>{{'LABEL_DISCOUNT_RATE_ROUNDING' | translate}}</mat-label>
              <mat-select id="id_disc_rate_round_decimal" #discountRateSelect formControlName="discountRateSelect" [value]="roundingOptions[0].value"
                required>
                <mat-option [id]="'id_disc_rate_round_data_' + (i+1)" *ngFor="let option of roundingOptions; let i = index" [value]="option.value">
                  {{option.viewValue}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formGroupDescription.controls['discountRateSelect'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- LABEL_DISCOUNT_RATE_DECIMAL -->
          <div fxLayout="row">
            <mat-form-field>
              <input id="id_disc_rate_dec_txtbox" matInput [placeholder]="'LABEL_DISCOUNT_RATE_DECIMAL' | translate" formControlName="decimal" [value]="2" required />

              <mat-error *ngIf="formGroupDescription.controls['decimal'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
              <mat-error *ngIf="formGroupDescription.controls['decimal'].hasError('maxlength')">
                {{ 'MSG_MAXLENGTH' | translate: {length: '1'} }}
              </mat-error>
              <mat-error *ngIf="formGroupDescription.controls['decimal'].hasError('valid')">
                {{ 'MSG_NUMBERS_ONLY' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- LABEL_TIER_BASE_DISCOUNT_TYPE -->
          <div fxLayout="row">
            <mat-form-field>
              <mat-label>Discount Tier</mat-label>
              <mat-select id="id_disc_tier_base_type" formControlName="discountTier" required>
                <mat-option [id]="'id_disc_tier_data_' + (i+1)" *ngFor="let option of tierBaseDiscountoptions; let i = index" [value]="option.value">
                  {{ option.viewValue }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formGroupDescription.controls['discountRateSelect'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" *ngIf="isSelectedDiscountTierPeriod">
            <mat-form-field>
              <mat-label>{{ 'LABEL_PERIOD_TIER' | translate }}</mat-label>
              <mat-select id="id_prd_tier_dropdown" formControlName="mechanicPeriodBasis" required>
                <mat-option [id]="'id_prd_tier_data_' + (i+1)" *ngFor="let option of periodTierOptions; let i = index" [value]="option.value">
                  {{option.viewValue}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formGroup.controls['periodTier'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- LABEL_ACCUMULATED_PURCHASE -->
          <!-- <div fxLayout="column">
            <div fxLayout="row">
              <label id="id_accm_purch_lbl" class="color-gray">{{'LABEL_ACCUMULATED_PURCHASE' | translate}}</label>
              <mat-slide-toggle id="id_accm_purch_switch" class="padding-left-5" formControlName="accumulatedPurchase" #toggle1
                color="primary">
                <!~~ <div>  {{ toggle1.checked }}</div> ~~>
              </mat-slide-toggle>
            </div>
          </div> -->
        </div>
      </div>
    </form>
  </mat-card>

  <!-- "Detail" Panel -->
  <div fxLayout="row" fxFlexFill>
    <mat-accordion fxFlexFill id="formWithAcordion">
      <mat-expansion-panel fxLayout="column" #expansionPanel [disabled]="viewMode"> <!--[class.disable]="(promoDetails.length > 0) && !editMode" -->
        <mat-expansion-panel-header>
          <mat-panel-title id="id_detail_header" flex="50">
            <!-- Condition Data -->
            {{ 'LABEL_CONDITION_DETAIL' | translate }}
          </mat-panel-title>
          <mat-panel-description class="italic-margin-left" flex="50">
            {{ 'LBL_ADD_NEW_CONDITION' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="column">
          <form [formGroup]="formGroup" class="card-header">
            <div fxFlex fxLayout fxLayoutGap="15px">
              <div fxFlex>

                <!-- LABEL_PROMO_NAME -->
                <div fxLayout="row">
                  <mat-form-field>
                    <input id="id_promo_name_txtbox" matInput [placeholder]="'LABEL_PROMO_NAME' | translate" formControlName="description" required/>
                    <mat-error *ngIf="formGroup.controls['description'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                    <mat-error *ngIf="formGroup.controls['description'].hasError('maxlength')">
                      {{ 'MSG_MAXLENGTH' | translate: {length: '255'} }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_RESET_PERIOD -->
                <div fxLayout="row">
                  <mat-form-field>
                    <mat-label>Reset Period</mat-label>
                    <mat-select id="id_rst_prd_dropdown" #maxSKUResetPeriodSelect [value]="maxSKUresetPeriod[0].value"
                      formControlName="resetPeriod" required>
                      <mat-option [id]="'id_rst_prd_data_' + (i+1)" *ngFor="let option of maxSKUresetPeriod; let i = index" [value]="option.value">
                        {{option.viewValue}}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="formGroup.controls['resetPeriod'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_RESET_PERIOD_NUM -->
                <div fxLayout="row">
                  <mat-form-field>
                    <input id="id_rst_prd_no_txtbox" matInput [placeholder]="'LABEL_RESET_PERIOD_NUM' | translate" disabled="!maxSKUResetPeriodSelect.empty" formControlName="resetPeriodNo" required/>

                    <mat-error *ngIf="formGroup.controls['resetPeriodNo'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['resetPeriodNo'].hasError('maxlength')">
                      {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['resetPeriodNo'].hasError('min')">
                      {{ 'MSG_MIN' | translate: {quantity: 1} }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['resetPeriodNo'].hasError('pattern')">
                      {{ 'MSG_NUMBERS_ONLY' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- resetDay -->
                <div fxLayout="row">
                  <mat-form-field>
                    <mat-label>Reset Day</mat-label>
                    <mat-select id="id_rst_day_dropdown" #resetDaySelect [value]="resetDayOptions[0].value" formControlName="resetDay" required>
                      <mat-option [id]="'id_rst_day_data_' + (i+1)" *ngFor="let option of resetDayOptions; let i = index" [value]="option.value">
                        {{option.viewValue}}
                      </mat-option>
                    </mat-select>
                        
                    <mat-error *ngIf="formGroup.controls['resetDay'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_CAP -->
                <div fxLayout="row">
                  <mat-form-field>
                    <input id="id_cap_txtbox" matInput [placeholder]="'LABEL_CAP' | translate" formControlName="cap" />

                    <mat-checkbox id="id_cap_infinite_checkbox" class="example-margin" formControlName="capInfinite" matSuffix class="padding-right-15"> {{ 'LBL_INFINITE' | translate }}</mat-checkbox>

                    <mat-error *ngIf="formGroup.controls['cap'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                    <mat-error *ngIf="formGroup.controls['cap'].hasError('maxlength')">
                      {{ 'MSG_MAXLENGTH' | translate: {length: '4' } }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['cap'].hasError('valid')">
                      {{ 'MSG_NUMBERS_ONLY' | translate }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['cap'].hasError('min')">
                      {{ 'MSG_MIN' | translate: {quantity: 1} }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_NTH_PIECE -->
                <div fxLayout="row">
                  <mat-form-field>
                    <input id="id_nth_pc_txtbox" matInput [placeholder]="'LABEL_NTH_PIECE' | translate" formControlName="nthPiece" />

                    <mat-error *ngIf="formGroup.controls['nthPiece'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                    <mat-error *ngIf="formGroup.controls['nthPiece'].hasError('maxlength')">
                      {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['nthPiece'].hasError('valid')">
                      {{ 'MSG_NUMBERS_ONLY' | translate }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['nthPiece'].hasError('min')">
                      {{ 'MSG_MIN' | translate: {quantity: 1} }}
                    </mat-error>
                  </mat-form-field>
                </div>
                
                <!-- LABEL_APPLY_DISCOUNT_TO -->
                <div fxLayout="row">
                  <mat-form-field>
                    <mat-label>{{'LABEL_APPLY_DISCOUNT_TO' | translate}}</mat-label>
                    <mat-select id="id_apply_disc_dropdown" #periodTierSelect [value]="applyDiscountToOption[0].value"
                      formControlName="applyDiscountTo" required>
                      <mat-option [id]="'id_apply_disc_data_' + (i+1)" *ngFor="let option of applyDiscountToOption; let i = index" [value]="option.value">
                        {{option.viewValue}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroup.controls['applyDiscountTo'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxFlex>
                <!-- LABEL_APPLY_TO / BRAND-->
                <div fxLayout="row">
                  <mat-form-field class="example-chip-list" *ngIf="distribution?.distribution_sku_mode != 'SKU'">
                    <mat-chip-list formControlName="applyToBrand" #chipsBrand aria-label="Brand selection">
                      <mat-chip [id]="'id_apply_to_brand_chip_btn_' + (i+1)" *ngFor="let brand of multiSelect.selectedBrands; let i = index" [removable]="removable" (removed)="remove(i, brand, brands, 'selectedBrands', 'applyToBrand')">
                        <div [id]="'id_apply_to_brand_chip_lbl_' + (i+1)" *ngIf="brand._sku">{{brand._sku._description}}</div>
                        <div [id]="'id_apply_to_brand_chip_lbl_' + (i+1)" *ngIf="brand._brand">{{brand._brand._description}}</div>
                        <div [id]="'id_apply_to_brand_chip_lbl_' + (i+1)" *ngIf="brand._category">{{brand._category._description}}</div>
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>

                      <input 
                        id="brandInput"
                        matInput                         
                        #brandInput 
                        formControlName="applyToBrandInput"
                        [matAutocomplete]="brandAC" 
                        [matChipInputFor]="chipsBrand" 
                        [matChipInputAddOnBlur]="true"
                        [placeholder]="'LABEL_APPLY_TO_BRAND' | translate" 
                        >
                    </mat-chip-list>

                    <mat-autocomplete id="id_apply_to_brand_dropdown" #brandAC="matAutocomplete" [displayWith]="displayFn" (opened)="autocompleteScroll('','brandACRef','brandACTr')">
                      <mat-option
                        disabled
                        *ngIf="!loading.brand && brands?.length == 0"
                        >
                        {{ 'MSG_NO_DATA' | translate }}
                      </mat-option>

                      <mat-option [id]="'id_apply_to_brand_data_' + (i+1)" *ngFor="let brand of filteredBrands | async; let i = index" [value]="selectedBrands" [disabled]="brand.disabled">
                        <div (click)="optionClicked($event, brand, brands, 'selectedBrands', 'applyToBrand')" [class.disable]="brand.disabled">
                          <mat-checkbox [id]="'id_apply_to_checkbox_' + (i+1)" [checked]="brand.selected" (change)="toggleSelection(brand, brands, 'selectedBrands', 'applyToBrand')"
                            (click)="$event.stopPropagation()">
                            <div *ngIf="brand._sku">{{brand._sku._description}}</div>
                            <div *ngIf="brand._brand">{{brand._brand._description}}</div>
                            <div *ngIf="brand._category">{{brand._category._description}}</div>
                          </mat-checkbox>
                        </div>
                      </mat-option>

                      <mat-option *ngIf="loading.brand" disabled>
                        <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                      </mat-option>
                    </mat-autocomplete>
                   
                    <!-- <mat-error *ngIf="formGroup.controls['applyToBrand'].hasError('required') || chipsBrand.errorState">
                      {{ 'MSG_FIELD_REQUIRED' | translate }}
                    </mat-error>  -->
                  </mat-form-field>
                </div>

                <!-- LABEL_APPLY_TO / SKU -->
                <div fxLayout="row">
                  <mat-form-field class="example-chip-list">
                    <mat-chip-list formControlName="applyTo" #chipList aria-label="Item selection" required>
                      <mat-chip [id]="'id_apply_to_chip_btn_' + (i+1)" *ngFor="let item of multiSelect.selectedItems; let i = index" [removable]="removable" (removed)="remove(i, item, items, 'selectedItems', 'applyTo')">
                        <div [id]="'id_apply_to_chip_lbl_' + (i+1)" *ngIf="item._sku">{{item._sku._description}}</div>
                        <div [id]="'id_apply_to_chip_lbl_' + (i+1)" *ngIf="item._brand">{{item._brand._description}}</div>
                        <div [id]="'id_apply_to_chip_lbl_' + (i+1)" *ngIf="item._category">{{item._category._description}}</div>
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>

                      <input 
                        id="itemInput"
                        matInput                         
                        #itemInput 
                        formControlName="applyToInput"
                        [matAutocomplete]="auto" 
                        [matChipInputFor]="chipList" 
                        [matChipInputAddOnBlur]="true"
                        [placeholder]="'LABEL_APPLY_TO' | translate" 
                        >
                    </mat-chip-list>
                    <mat-autocomplete id="id_apply_to_dropdown" #auto="matAutocomplete" [displayWith]="displayFn" (opened)="autocompleteScroll('','matAutocomplete','matAutocompleteACTr')">
                      <mat-option
                        disabled
                        *ngIf="!loading.item && items?.length == 0"
                        >
                        {{ 'MSG_NO_DATA' | translate }}
                      </mat-option>

                      <mat-option [id]="'id_apply_to_data_' + (i+1)" *ngFor="let item of filteredItems | async; let i = index" [value]="selectedItems" [disabled]="item.disabled">
                        <div (click)="optionClicked($event, item, items, 'selectedItems', 'applyTo')" [class.disable]="item.disabled">
                          <mat-checkbox [id]="'id_apply_to_checkbox_' + (i+1)" [checked]="item.selected" (change)="toggleSelection(item, items, 'selectedItems', 'applyTo')"
                            (click)="$event.stopPropagation()">
                            <div *ngIf="item._sku">{{item._sku._description}}</div>
                            <div *ngIf="item._brand">{{item._brand._description}}</div>
                            <div *ngIf="item._category">{{item._category._description}}</div>
                          </mat-checkbox>
                        </div>
                      </mat-option>

                      <mat-option *ngIf="loading.item" disabled>
                        <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                      </mat-option>
                    </mat-autocomplete>
                   
                    <mat-error *ngIf="formGroup.controls['applyTo'].hasError('required') || chipList.errorState">
                      {{ 'MSG_FIELD_REQUIRED' | translate }}
                    </mat-error> 
                  </mat-form-field>
                </div>

                <!-- LABEL_USE_DISTRIB_DATE -->
                <div fxLayout="column">
                  <div fxLayout="row">
                    <label class="color-gray">Use Distribution Redemption Date</label>
                    <mat-slide-toggle id="id_use_dist_red_date_switch" formControlName='useDistributionDates' [checked]='true' class="padding-left-5" #toggle3 color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>

                <!-- LABEL_DATE_RANGE_FROM -->
                <div fxLayout="row" *ngIf='!toggle3.checked'>
                  <mat-form-field>
                    <!-- kiko 22.Jan2020 -- removed ngModel -->
                    <!-- <input matInput placeholder="Date Range From" [matDatepicker]="DateRangeFrompicker"
                      (focus)="DateRangeFrompicker.open()" formControlName="dateRangeFrom" [(ngModel)]="dateRangeFrom"
                      readonly /> -->
                    <input id="id_date_range_from" matInput [placeholder]="'LABEL_DATE_RANGE_FROM' | translate" [matDatepicker]="DateRangeFrompicker" (focus)="DateRangeFrompicker.open()" formControlName="dateRangeFrom" [min]="minDate" [max]="maxDate" readonly />
                    <mat-datepicker #DateRangeFrompicker></mat-datepicker>
                    <mat-datepicker-toggle matSuffix [for]="DateRangeFrompicker"></mat-datepicker-toggle>
                    <mat-error *ngIf="formGroup.controls['dateRangeFrom'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_DATE_RANGE_TO -->
                <div fxLayout="row" *ngIf='!toggle3.checked'>
                  <mat-form-field>
                    <!-- kiko 22.Jan2020 -- removed ngModel -->
                    <!-- <input matInput placeholder="Date Range To" [matDatepicker]="DateRangeTopicker"
                      (focus)="DateRangeTopicker.open()" formControlName="dateRangeTo" [(ngModel)]="dateRangeTo"
                      readonly /> -->
                    <input id="id_date_range_to" matInput [placeholder]="'LABEL_DATE_RANGE_TO' | translate" [matDatepicker]="DateRangeTopicker" (focus)="DateRangeTopicker.open()" formControlName="dateRangeTo" [min]="minDate" [max]="maxDate" readonly />
                    <mat-datepicker #DateRangeTopicker></mat-datepicker>
                    <mat-datepicker-toggle matSuffix [for]="DateRangeTopicker"></mat-datepicker-toggle>
                    <mat-error *ngIf="formGroup.controls['dateRangeTo'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                  </mat-form-field>
                </div>

                <!-- LABEL_PRIORITY -->
                <div fxLayout="row">
                  <mat-form-field>
                    <input id="id_priority_txtbox" matInput [placeholder]="'LABEL_PRIORITY' | translate" formControlName="priority" required/>
                    <mat-error *ngIf="formGroup.controls['priority'].hasError('required')">
                      {{ 'MSG_FIELD_REQUIRED' | translate}}</mat-error>
                    <mat-error *ngIf="formGroup.controls['priority'].hasError('maxlength')">
                      {{ 'MSG_MAXLENGTH' | translate: {length: '2'} }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['priority'].hasError('pattern')">
                      {{ 'MSG_NUMBERS_ONLY' | translate }}
                    </mat-error> 
                    <mat-error *ngIf="formGroup.controls['priority'].hasError('min')">
                      {{ 'MSG_MIN' | translate: {quantity: 1} }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="mechanicForms">
            <div fxFlex fxLayout="column" fxLayoutGap="15px" class="width-100">
              <button 
                color="primary"
                mat-stroked-button 
                id="id_add_coup_mech_btn" 
                (click)="addRow(mechanicFormArray.controls)" 
                class="width-100 margin-top-20" 
                [disabled]="hasInfiniteMechanic(mechanicForms['controls'].items['controls'])"
                >
                {{ 'LABEL_ADD_MECHANIC' | translate }}
              </button>

              <!-- <div
                cdkDropList
                #todoList="cdkDropList"
                [cdkDropListData]="mechanicFormArray.controls"
                class="example-list"
                (cdkDropListDropped)="drop($event)"
                fxLayoutGap="10px"
                fxLayout="column">
              </div> -->
              <span id="id_sub_detail_header" *ngIf="mechanicFormArray.controls.length">
                {{ 'LABEL_CONDITION_SUB_DETAIL' | translate }}
              </span>

              <mat-card *ngFor="let item of mechanicFormArray.controls; let i = index" class="max-width-100">
                <mat-card-content class="margin-top-20" fxLayout="row" *ngIf="item">
                  <div [formGroup]="item" fxLayout="row" flex class="width-100">
                    <!-- sequence -->
                    <ng-container *ngIf="mechanicFormArray.controls[i].controls['sequence']">
                      <mat-form-field  class="mechanic-field-padding" flex>
                        <input [id]="'id_seq_txtbox_' + (i+1)" [placeholder]="'LABEL_SEQUENCE' | translate" [formControl]="mechanicFormArray.controls[i].controls['sequence']" matInput>

                        <mat-error *ngIf="item.controls['sequence'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['sequence'].hasError('duplicateSequence')">
                          {{ 'MSG_DUPLICATE_SEQUENCE' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['sequence'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['sequence'].hasError('maxlength')">
                          {{ 'MSG_MAXLENGTH' | translate: {length: '2'} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['sequence'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: 1} }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>

                    <!-- from / fromInfinite -->
                    <ng-container *ngIf="(mechanicFormArray.controls[i].controls['from'] || mechanicFormArray.controls[i].controls['fromInfinite']) && !isSelectedDiscountTierNone">
                      <mat-form-field class="mechanic-field-padding" flex>
                        <input [id]="'id_from_txtbox_' + (i+1)" [placeholder]="(isSelectedDiscountTierPeriod ? 'LABEL_PERIOD_FROM' : 'LABEL_TRANSACTION_COUNT_FROM') | translate" [formControl]="mechanicFormArray.controls[i].controls['from']" required matInput>

                        <mat-checkbox [id]="'id_from_checkbox_' + (i+1)" class="example-margin" [formControl]="mechanicFormArray.controls[i].controls['fromInfinite']" matSuffix class="padding-right-15"> {{ 'LBL_INFINITE' | translate }}</mat-checkbox>
  
                        <mat-error *ngIf="item.controls['from'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['from'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['from'].hasError('maxlength')">
                          {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['from'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: 1} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['from'].hasError('smaller')">
                          {{ 'MSG_TXN_COUNT_LESS_THAN_PREV_VALUE' | translate: {value: mechanicFormArray.controls[i-1].controls['to'].value} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['from'].hasError('greaterThanTo')">
                          {{ 'MSG_NOT_GREATER_THAN' | translate: { 
                                src: isSelectedDiscountTierPeriod ? 'Period From' : 'Transaction Count From',
                                target: isSelectedDiscountTierPeriod ? 'Period To' : 'Transaction Count To'
                            } 
                          }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                    
                    <!-- to / toInfinite -->
                    <ng-container *ngIf="(mechanicFormArray.controls[i].controls['to'] || mechanicFormArray.controls[i].controls['toInfinite']) && !isSelectedDiscountTierNone">
                      <mat-form-field class="mechanic-field-padding" flex>
                        <input [id]="'id_to_txtbox_' + (i+1)" [placeholder]="(isSelectedDiscountTierPeriod ? 'LABEL_PERIOD_TO' : 'LABEL_TRANSACTION_COUNT_TO') | translate" [formControl]="mechanicFormArray.controls[i].controls['to']" required matInput>

                        <mat-checkbox [id]="'id_to_checkbox_' + (i+1)" class="example-margin" [formControl]="mechanicFormArray.controls[i].controls['toInfinite']" matSuffix class="padding-right-15"> {{ 'LBL_INFINITE' | translate }}</mat-checkbox>
  
                        <mat-error *ngIf="item.controls['to'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['to'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['to'].hasError('maxlength')">
                          {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['to'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: 1} }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>

                    <!-- min / minInfinite -->
                    <ng-container *ngIf="mechanicFormArray.controls[i].controls['min'] || mechanicFormArray.controls[i].controls['minInfinite']">
                      <mat-form-field class="mechanic-field-padding" flex>
                        <input [id]="'id_min_txtbox_' + (i+1)" [placeholder]="'LABEL_MIN_PURCHASE' | translate" [formControl]="mechanicFormArray.controls[i].controls['min']" required matInput>

                        <mat-checkbox [id]="'id_min_checkbox_' + (i+1)" class="example-margin" [formControl]="mechanicFormArray.controls[i].controls['minInfinite']" matSuffix class="padding-right-15"> {{ 'LBL_INFINITE' | translate }}</mat-checkbox>
  
                        <mat-error *ngIf="item.controls['min'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('notAfterInfinite')">
                          {{ 'MSG_NOT_AFTER_INFINITE' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('smaller')">
                           {{ 'MSG_MIN_LESS_THAN_MAX' | translate: {value: mechanicFormArray.controls[i-1].controls['max'].value} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('maxlength')">
                          {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: (formGroup.get('nthPiece').value > 1 ? formGroup.get('nthPiece').value : 1)} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['min'].hasError('greaterThanMax')">
                          {{ 'MSG_NOT_GREATER_THAN' | translate: {src: 'Min Purchase', target: 'Max Purchase'} }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>

                    <!-- max / maxInfinite -->
                    <ng-container *ngIf="mechanicFormArray.controls[i].controls['max'] || mechanicFormArray.controls[i].controls['maxInfinite']">
                      <mat-form-field class="mechanic-field-padding" flex>
                        <input [id]="'id_max_txtbox_' + (i+1)" [placeholder]="'LABEL_MAX_PURCHASE' | translate" [formControl]="mechanicFormArray.controls[i].controls['max']" required matInput>

                        <mat-checkbox [id]="'id_max_checkbox_' + (i+1)" class="example-margin" [formControl]="mechanicFormArray.controls[i].controls['maxInfinite']" matSuffix class="padding-right-15"> {{ 'LBL_INFINITE' | translate }}</mat-checkbox>
  
                        <mat-error *ngIf="item.controls['max'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['max'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['max'].hasError('maxlength')">
                          {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['max'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: 1} }}
                        </mat-error>
                         <mat-error *ngIf="item.controls['max'].hasError('greaterThanMin')">
                          {{ 'MSG_NOT_LESS_THAN' | translate: {src: 'Max purchase', target: 'Min purchase'} }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>

                    <!-- discount -->
                    <ng-container *ngIf="mechanicFormArray.controls[i].controls['discount']">
                      <mat-form-field class="mechanic-field-padding" flex>
                        <input [id]="'id_disc_txtbox_' + (i+1)" placeholder="Discount" [formControl]="mechanicFormArray.controls[i].controls['discount']" matInput required>
  
                        <mat-error *ngIf="item.controls['discount'].hasError('required')">
                          {{ 'MSG_FIELD_REQUIRED' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('valid')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('numWithDecimal')">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('pattern')">
                          {{ 'MSG_NO_DECIMAL_PLACES' | translate }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('decimalErr')">
                          {{ 'MSG_ERROR_DECIMAL_PLACES' | translate: {places: 2} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('min')">
                          {{ 'MSG_MIN' | translate: {quantity: 0.01} }}
                        </mat-error>
                        <mat-error *ngIf="item.controls['discount'].hasError('max')">
                          {{ formGroupDescription.get('discountTypeSelect').value == "1" ?('MSG_MAX_DISCOUNT_AMOUNT' | translate: {amount: 1000}) : ('MSG_MAX_DISCOUNT_RATE' | translate: {amount: 100}) }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                  </div>
                </mat-card-content>
                
                <div class="remove-mechanic" fxLayoutAlign="center center">
                  <button [id]="'id_edit_cond_btn_' + (i+1)" mat-button color="warn" (click)="removeMechanic(item)" [disabled]="promoDetails.length > 0">
                    <mat-icon svgIcon="minus-circle"></mat-icon>
                  </button>
                </div>
              </mat-card>

            </div>
          </form>

          <div fxFlex fxLayout fxLayoutAlign="center center">
            <button mat-icon-button class="width-100 margin-top-20" color="primary"
              (click)="addCondition(formGroup, mechanicForms['controls'].items['controls'])">
              {{ 'LABEL_DONE' | translate }}
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div>
    <h1 id="id_cond_list_header" class="title padding-top-20" fxLayoutAlign="center center">
      {{ 'LABEL_CONDITION_LIST' | translate }}
    </h1>
  </div>

  <hr>

  <div fxLayout="row wrap">
    <div *ngFor="let promo of promoDetails; let i = index" fxFlex="50">
      <mat-card class="card-condition">
        <mat-card-title [id]="'id_promo_name_lbl_' + (i+1)">
          {{ promo.description }}
        </mat-card-title>
        <mat-card-title-group>
          <div fxLayout="row" fxFlex>
            <div fxLayout="column" fxFlex>
              <mat-card-subtitle [id]="'id_reset_period_lbl_' + (i+1)">
                Reset Period: {{ promo.capacity_reset_period}}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_reset_period_no_lbl_' + (i+1)">
                Reset Period No: {{ promo.capacity_reset_period_qty }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_reset_day_lbl_' + (i+1)">
                Reset Day: {{ promo.capacity_reset_day | translate }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_capacity_lbl_' + (i+1)">
                Capacity: {{ promo.capacity == -1 ? ('LABEL_INFINITE' | translate) : promo.capacity }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_nth_pc_lbl_' + (i+1)">
                Nth Piece: {{ promo.apply_for_every_nth_pcs }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_apply_disc_to_lbl_' + (i+1)">
                Apply Discount to: {{ promo.apply_discount_to == "EACH_PCS" ? ('EACH_PCS' | translate) : ('NTH_PCS' | translate) }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_from_lbl_' + (i+1)">
                From: {{ (formGroup?.get('useDistributionDates').value == 1 && !promo.start_date) ? (distribution?.start_date | date: 'yyyy-MM-dd') : promo.start_date }}
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_to_lbl_' + (i+1)">
                To: {{ (formGroup?.get('useDistributionDates').value == 1 && !promo.end_date) ? (distribution?.end_date | date: 'yyyy-MM-dd') : promo.end_date }} 
              </mat-card-subtitle>

              <mat-card-subtitle [id]="'id_priority_lbl_' + (i+1)">
                Priority: {{ promo.priority }}
              </mat-card-subtitle>
            </div>

            <div fxLayout="column" fxFlex>

              <ng-container *ngIf="promo.distribution_promo_brand">
                <mat-card-subtitle>
                  <span [id]="'id_apply_to_brands_lbl_' + (i+1)">Brands:</span> 
  
                  <!-- <ng-container *ngIf="!displayAllItems(promo.distribution_promo_brand)"> -->
                    <div *ngFor="let item of promo.distribution_promo_brand; let p = index">
                      <div [id]="'id_item_lbl_' + (i+1) + '_' + (p+1)" *ngIf="item._sku">
                        {{item._sku._description}}
                      </div>
    
                      <div [id]="'id_item_lbl_' + (i+1) + '_' + (p+1)" *ngIf="item._brand">
                        {{item._brand._description}}
                      </div>
    
                      <div [id]="'id_item_lbl_' + (i+1) + '_' + (p+1)" *ngIf="item._category">
                        {{item._category._description}}
                      </div>
                    </div>
                  <!-- </ng-container> -->
  
                  <!-- <div *ngIf="displayAllItems(promo.distribution_promo_brand)">
                    {{ 'LABEL_ALL' | translate }}
                  </div> -->
                </mat-card-subtitle>
              </ng-container>

              <mat-card-subtitle>
                <span [id]="'id_apply_to_lbl_' + (i+1)">Apply To:</span> 

                <!-- <ng-container *ngIf="!displayAllItems(promo.distribution_promo_sku)"> -->
                  <div *ngFor="let item of promo.distribution_promo_sku; let p = index">
                    <div [id]="'id_item_lbl_' + (i+1) + '_' + (p+1)">
                      {{ item._sku?._description || item._brand?._description || item._category?._description }} <!-- Added for prioritization in display, in case promo item has sku, brand, category -->
                    </div>
                  </div>
                <!-- </ng-container> -->

                <!-- <div *ngIf="displayAllItems(promo.distribution_promo_sku)">
                  {{ 'LABEL_ALL' | translate }}
                </div> -->
              </mat-card-subtitle>

            </div>
          </div>
        </mat-card-title-group>

        <mat-card-footer fxFlexFill class="footer">
          <table mat-table #tableDetailView [dataSource]="promo.distribution_promo_mechanic" class="mat-elevation-z8" class="width-100">

            <ng-container matColumnDef="Sequence">
              <th [id]="'id_sequence_header_' + (i+1)" mat-header-cell *matHeaderCellDef>Sequence</th>
              <td [id]="'id_sequence_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">{{ element.sequence }}</td>
            </ng-container>

            <ng-container matColumnDef="From" *ngIf="!isSelectedDiscountTierNone">
              <th [id]="'id_from_header_' + (i+1)" mat-header-cell *matHeaderCellDef>From</th>
              <td [id]="'id_from_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
                <ng-container *ngIf="isSelectedDiscountTierTransactionCount; else periodCountFrom">
                  {{ element.mechanic_transaction_count_from_qty == -1 ? ('LABEL_INFINITE' | translate) : element.mechanic_transaction_count_from_qty }}
                </ng-container>
                <ng-template #periodCountFrom>
                  {{ element.mechanic_period_from_qty == -1 ? ('LABEL_INFINITE' | translate) : element.mechanic_period_from_qty }}
                </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="To" *ngIf="!isSelectedDiscountTierNone">
              <th [id]="'id_to_header_' + (i+1)" mat-header-cell *matHeaderCellDef>To</th>
              <td [id]="'id_to_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
                <ng-container *ngIf="isSelectedDiscountTierTransactionCount; else periodCountTo">
                  {{ element.mechanic_transaction_count_to_qty == -1 ? ('LABEL_INFINITE' | translate) : element.mechanic_transaction_count_to_qty }}
                </ng-container>
                <ng-template #periodCountTo>
                  {{ element.mechanic_period_to_qty == -1 ? ('LABEL_INFINITE' | translate) : element.mechanic_period_to_qty }}
                </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="Min">
              <th [id]="'id_min_header_' + (i+1)" mat-header-cell *matHeaderCellDef>Min</th>
              <td [id]="'id_min_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
                {{ element.purchase_min == -1 ? ('LABEL_INFINITE' | translate) : element.purchase_min }}
              </td>
            </ng-container>

            <ng-container matColumnDef="Max">
              <th [id]="'id_max_header_' + (i+1)" mat-header-cell *matHeaderCellDef>Max</th>
              <td [id]="'id_max_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
                {{ element.purchase_max == -1 ? ('LABEL_INFINITE' | translate) : element.purchase_max }}
              </td>
            </ng-container>

            <ng-container matColumnDef="Discount">
              <th [id]="'id_discount_header_' + (i+1)" mat-header-cell *matHeaderCellDef>Discount</th>
              <td [id]="'id_discount_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
                {{ element.discount_value }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          </table>
        </mat-card-footer>

        <button [id]="'id_edit_cond_btn_' + (i+1)" mat-mini-fab color="none" (click)="edit(condition, i, tableDetailView)" class="edit-mechanic" [disabled]="viewMode">
          <mat-icon svgIcon="pencil"></mat-icon>
        </button>
      </mat-card>
    </div>
  </div>
</div>